import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./AuthProvider";
import { AvatarProvider } from "./contexts/AvatarContext";
import { SnackbarProvider } from "notistack";
import { UserProvider } from "./contexts/UserContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AvatarProvider>
        <UserProvider>
          <SnackbarProvider maxSnack={3}>
            <App />
          </SnackbarProvider>
        </UserProvider>
      </AvatarProvider>
    </AuthProvider>
  </React.StrictMode>
);
